import { NavigationGuardNext, Route } from 'vue-router';
import { canOpenSubscriptionPage, loggedIn } from '@/ui/auth/auth';
import { NamedLocation } from '../types';

export function guardSubscriptionPage(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (!loggedIn.value) {
    next({ name: 'login' });
  } else {
    if (!canOpenSubscriptionPage()) {
      const redirectTo: NamedLocation = { name: 'forbidden' };
      next(redirectTo);
      return;
    }

    next();
  }
}
